import API from '@/Api/api_data';
import { WeatherParam, WeatherData } from '@/interfaces/weather_interface';

const Weather = {
    state: {
        weatherDataList: new Array<WeatherData>(),
    },
    getters: {
        /**
         * @author guan
         * @description  返回天气数据
         * @param state weatherData 天气数据
         * @return void
         */
        getWeatherData: (state: { weatherDataList: WeatherData[] }) => {
            return state.weatherDataList;
        },
    },
    mutations: {
        /**
         * @author guan
         * @description 设置天气数据
         * @return void
         */
        setWeatherData: (state: { weatherDataList: WeatherData[] }, params: WeatherData[]) => {
            state.weatherDataList = params;
        },
    },
    actions: {
        getWeatherDataByLocation: () => (param: WeatherParam) => {
            API.loadWeaterData(param)
                .then((res: any) => {})
                .catch((error) => error);
        },
    },
};
export default Weather;
